import { take, takeLatest } from "redux-saga/effects";
import { Creators as AllCreators, Types as AllTypes } from "../../actions";
import * as actions from "../../actions/dashboard/dashboard.actions";
import {
  fetchAllDashboardData,
  fetchCourseCompletionAnalytics,
  loadAllCourses,
  loadMoreCourses,
  searchCoursesByName,
} from "../../actions/dashboard/dashboard.sagas";

const Creators = (AllCreators as any).App.Dashboard;
const Types = (AllTypes as any)._APP._DASHBOARD;

export function* watchFetchAllDashboardData() {
  yield takeLatest(
    Types.FETCH_ALL_DASHBOARD_DATA,
    fetchAllDashboardData(
      {
        onFailure: Creators.handleFetchAllDashboardDataFailure,
        onSuccess: Creators.handleFetchAllDashboardDataSuccess,
      },
      actions.LIMIT_COURSES
    )
  );
}

export function* watchFetchCourseCompletionAnalytics() {
  yield takeLatest(
    Types.FETCH_COURSE_COMPLETION_ANALYTICS,
    fetchCourseCompletionAnalytics({
      onFailure: Creators.handleFetchCourseCompletionAnalyticsFailure,
      onSuccess: Creators.handleFetchCourseCompletionAnalyticsSuccess,
    })
  );
}

export function* watchLoadAllCourses() {
  yield takeLatest(
    actions.LOAD_ALL_COURSES,
    loadAllCourses({
      onFailure: actions.handleLoadMoreCoursesFailure,
      onSuccess: actions.handleLoadMoreCoursesSuccess,
    })
  );
}

export function* watchLoadMoreCourses() {
  yield takeLatest(
    actions.LOAD_MORE_COURSES,
    loadMoreCourses(
      {
        onFailure: actions.handleLoadMoreCoursesFailure,
        onSuccess: actions.handleLoadMoreCoursesSuccess,
      },
      actions.LIMIT_COURSES
    )
  );
}

export function* watchSearchCoursesByName() {
  yield takeLatest(
    actions.SEARCH_COURSES_BY_NAME,
    searchCoursesByName(
      {
        onFailure: actions.handleSearchCoursesByNameFailure,
        onSuccess: actions.handleSearchCoursesByNameSuccess,
      },
      actions.LIMIT_COURSES
    )
  );
}

export function* watchMount() {
  yield take(Types.MOUNT);
}

export function* watchUnmount() {
  yield take(Types.UNMOUNT);
}
